import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const addAttributeToSensitivePropertyGroup =
  (groupName: string, attributeIri: string) => (model: Model) => {
    const existingAttributeIris =
      model.modelData.sensitivePropertyGroupsByName[groupName];

    const isAttributeAlreadyInGroup =
      existingAttributeIris?.includes(attributeIri);
    const doesAttributeExist = Boolean(
      model.modelData.attributesByIri[attributeIri]
    );

    if (
      !existingAttributeIris ||
      isAttributeAlreadyInGroup ||
      !doesAttributeExist
    ) {
      return;
    }

    setDataProperty<ModelData>(model)(
      model.modelData,
      'sensitivePropertyGroupsByName',
      {
        ...model.modelData.sensitivePropertyGroupsByName,
        [groupName]: [...existingAttributeIris, attributeIri],
      }
    );
  };
